// src/store/mutations.js
export default {
    // 设置用户信息
    setUserInfo(state, userInfo) {
        state.userinfo = {
            ...state.userinfo,
            ...userInfo
        };
        state.userid = userInfo.userid;
    },
    // 清除用户信息
    clearUserInfo(state) {
        state.userinfo = {
            userid:'',
            username:'',
            userpassword:'',
            userposition:'',
            role: '',
            permissions: []
        };
        state.userid = '';
        // 从localStorage删除
        localStorage.removeItem('userInfo');
    }
}